import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// A power-factor capacitor bank: a steel rack holding a grid of cylindrical
// capacitor cans, each topped with two bushings and tied by busbars. Corrects
// reactive power on a feeder.
const FRAME = "#6c727a";
const CAN = "#aeb4ba";
const CAN_TOP = "#8f969c";
const BUSH = "#9aa6ad";
const BUS = "#b87333";

function can(x: number, y: number, z: number): Part[] {
  return [
    { geometry: new THREE.CylinderGeometry(0.07, 0.07, 0.28, 12), color: CAN, position: [x, y, z] },
    { geometry: new THREE.CylinderGeometry(0.075, 0.075, 0.03, 12), color: CAN_TOP, position: [x, y + 0.15, z] },
    { geometry: new THREE.CylinderGeometry(0.016, 0.02, 0.06, 8), color: BUSH, position: [x - 0.03, y + 0.19, z] },
    { geometry: new THREE.CylinderGeometry(0.016, 0.02, 0.06, 8), color: BUSH, position: [x + 0.03, y + 0.19, z] },
  ];
}

export const capacitorBank = defineModel({
  id: "capacitor-bank",
  batchId: "electric",
  name: "Capacitor bank",
  tags: ["prop", "electric", "power", "grid", "capacitor", "substation"],
  summary: "A rack of capacitor cans with bushings and busbars.",
  footprint: 0.5,
  parts(): Part[] {
    const parts: Part[] = [
      { geometry: new THREE.BoxGeometry(0.9, 0.06, 0.4), color: FRAME, position: [0, 0.03, 0] },
    ];
    // Two posts and an upper rail per side.
    for (const x of [-0.42, 0.42]) {
      parts.push({ geometry: new THREE.BoxGeometry(0.04, 0.66, 0.36), color: FRAME, position: [x, 0.36, 0], scale: [1, 1, 1] });
    }
    parts.push({ geometry: new THREE.BoxGeometry(0.9, 0.04, 0.4), color: FRAME, position: [0, 0.36, 0] });
    // Two rows of three cans (lower and upper tier).
    const xs = [-0.28, 0, 0.28];
    for (const z of [-0.1, 0.1]) for (const x of xs) parts.push(...can(x, 0.5, z));
    // Busbars across the tops.
    for (const z of [-0.1, 0.1]) {
      parts.push({ geometry: new THREE.CylinderGeometry(0.016, 0.016, 0.66, 8), color: BUS, position: [0, 0.7, z], rotation: [0, 0, Math.PI / 2] });
    }
    return parts;
  },
  animations: [],
});
